var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDots = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 8,
  r: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 24,
  r: 2
})));
export default SvgDots;